// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 818) return "static/css/818.83605f3b567ed30e8a07.lib.css";
	if (chunkId === 224) return "static/css/224.28bd93c488df4522fe5f.css";
	if (chunkId === 949) return "static/css/949.26c4680c9abbbb83c280.css";
	if (chunkId === 697) return "static/css/697.11f14d838f7fd3c876b9.css";
	// return url for filenames based on template
	return undefined;
};